export default __webpack_public_path__ + "static/media/aimate-screenshot-06.43669fcc.png";